import { useContext, useMemo } from "react";

// Contexts
import { PayPlanContext } from "@PayPlans/context/PayPlans/PayPlanProvider";

function usePayPlan() {
	const context = useContext(PayPlanContext);
	if (!context) {
		throw new Error("Hook usePayPlan must be used within a PayPlanProvider");
	}
	return context;
}

const usePayPlanStore = (store: unknown) => {
	return useMemo(() => store, [store]);
};

export { PayPlanContext, usePayPlan, usePayPlanStore };
